import styled from 'styled-components';

export const Container = styled.div`
  background-color: #00ffff;
  padding: 16px;
  margin: 16px 0;
  border-radius: 8px;
  box-shadow: #00000029 0px 3px 6px;
  color: #0000ff;
  font-family: 'Mangueira';
  font-size: 16px;
`;

export const Title = styled.h5`
  font-size: 16px;
  font-weight: 700;
  color: #0000ff;
  font-family: 'Mangueira';
  font-size: 16px;
`;

export const Text = styled.span`
  display: inline-flex;
`;
